<template>
  <div class="fair-survey-step">
    <div class="fair-survey-step__head">
      <h2 class="fair-survey-step__title">
        {{ step.title }}
      </h2>
      <p
        v-if="step.subtitle"
        class="fair-survey-step__subtitle"
      >
        {{ step.subtitle }}
      </p>
    </div>

    <div
      class="fair-survey-step__options"
      role="radiogroup"
      :aria-label="step.title"
    >
      <button
        v-for="option in GENDER_OPTIONS"
        :key="option.value"
        type="button"
        role="radio"
        class="fair-survey-step__option"
        :class="{
          'fair-survey-step__option--selected': selectedGender === option.value,
        }"
        :aria-checked="selectedGender === option.value"
        @click="selectGender(option.value)"
      >
        <FairRadioButtonIndicator :selected="selectedGender === option.value" />
        <span class="fair-survey-step__option-label">{{ option.label }}</span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useTasteClarificationModal } from '@/features/taste/store'
import type { GenderValue, TasteStep } from '@/features/taste/types/taste-config'
import { FairRadioButtonIndicator } from '@/ui/primitives/FairRadioButton'

defineProps<{ step: TasteStep & { type: 'gender' } }>()

const tasteStore = useTasteClarificationModal()
const selectedGender = ref<GenderValue | null>(null)

const GENDER_OPTIONS: Array<{ value: GenderValue; label: string }> = [
  { value: 'female', label: 'Женский' },
  { value: 'male', label: 'Мужской' },
]

function selectGender(gender: GenderValue) {
  selectedGender.value = gender
  tasteStore.updateTasteData('gender', gender)
}

onMounted(() => {
  selectedGender.value = tasteStore.tasteModal.tasteData.gender || null
})
</script>
